module.exports = __webpack_public_path__ + "img/dynamic_4.2912c113.png";